import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const SettingsContext = createContext({});

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({});
    const [rates, setRates] = useState({});

    const refresh = async () => {
        try {
            const [{ data: s }, { data: r }] = await Promise.all([
                client.get("/settings"),
                client.get("/rates"),
            ]);
            setSettings(s || {});
            setRates(r || {});
        } catch {}
    };
    useEffect(() => { refresh(); }, []);
    return (
        <SettingsContext.Provider value={{ settings, rates, refresh }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() { return useContext(SettingsContext); }
